const normalize = (s) =>
  String(s ?? "")
    .replace(/\s+/g, " ")
    .trim();

// Единый "справочник" перевода лабораторий RU -> KZ (фронт).
// Если в БД нет nameKz, используем это сопоставление.
export const LABORATORY_RU_TO_KZ = Object.freeze({
  [normalize("Молекулярно-генетическая лаборатория")]: "Молекулярлық-генетикалық зертхана",
  [normalize("Оперативные услуги")]: "Жедел қызметтер",
  [normalize("Лаборатория высокотехнологических исследований")]: "Жоғары технологиялық зерттеулер зертханасы",
  [normalize("Очаговая дезинфекция, дезинсекция и дератизация")]: "Ошақтық дезинфекция, дезинсекция және дератизация",
  [normalize("Лаборатория карантинных и особо-опасных инфекций")]: "Карантиндік және аса қауіпті инфекциялар зертханасы",
  [normalize("Лаборатория карантинных и особо опасных инфекций")]: "Карантиндік және аса қауіпті инфекциялар зертханасы",
  [normalize("Вирусологическая лаборатория")]: "Вирусологиялық зертхана",
  [normalize("Паразитологическая лаборатория")]: "Паразитологиялық зертхана",
  [normalize("Радиологическая лаборатория")]: "Радиологиялық зертхана",
  [normalize("Отделение электромагнитных полей и других физических факторов")]:
    "Электромагниттік өрістер және басқа физикалық факторлар бөлімі",
  [normalize("Лаборатория токсикологии полимеров и других химических веществ")]:
    "Полимерлер мен басқа химиялық заттардың токсикологиясы зертханасы",
  [normalize("Лаборатория токсикологии пестицидов")]: "Пестицидтер токсикологиясы зертханасы",
  [normalize("Бактериологическая лаборатория")]: "Бактериологиялық зертхана",
  [normalize("Санитарно-химическая лаборатория")]: "Санитариялық-химиялық зертхана",
});

export function translateLaboratoryNameToKz(labNameRu) {
  const key = normalize(labNameRu);
  return LABORATORY_RU_TO_KZ[key] || "";
}

